import { css, SerializedStyles } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getEmailTemplateSectionStyles = (theme: Theme): SerializedStyles =>
    css({
        maxWidth: '600px',
        height: 'max-content',
        margin: `${theme.spacing(6)}px auto`,
    });

export const getNonEditableContentStyles = (): SerializedStyles =>
    css({
        opacity: 0.5,
    });

export const getInfoCardsWrapperStyles = (theme: Theme): SerializedStyles =>
    css({
        display: 'flex',
        justifyContent: 'space-between',
        columnGap: theme.spacing(2),
    });

export const getCompanyLogoWrapperStyles = (theme: Theme): SerializedStyles =>
    css({
        height: '92px',
        width: 'auto',
        objectFit: 'contain',
        marginBottom: theme.spacing(2),
        opacity: 0.5,
    });

export const getPlaceholderLogoWrapperStyles = (theme: Theme): SerializedStyles =>
    css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '92px',
        width: '92px',
        marginBottom: theme.spacing(2),
        border: `2px dashed ${theme.palette.gray[300]}`,
        textAlign: 'center',
        opacity: 0.5,
        p: {
            marginBottom: 0,
        },
    });

export const getInfoCaptionStyles = (theme: Theme): SerializedStyles =>
    css({
        lineHeight: theme.typography.lineHeight.M,
        marginBottom: theme.spacing(),
    });

export const getInfoNumberStyles = (theme: Theme): SerializedStyles =>
    css({
        lineHeight: theme.typography.lineHeight.XXL,
        marginBottom: theme.spacing(),
    });

export const getCarrierLogoStyles = (): SerializedStyles =>
    css({
        height: '50px',
        width: 'auto',
        objectFit: 'contain',
    });

export const getJourneyLinkStyles = (): SerializedStyles =>
    css({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    });

export const getImageUploaderStyles = (): SerializedStyles =>
    css({
        width: 'fit-content',
        img: {
            maxHeight: 110,
            maxWidth: 270,
        },
    });

export const getEmailBodyStyles = (theme: Theme): SerializedStyles =>
    css({
        backgroundColor: theme.palette.white,
        padding: theme.spacing(3),
    });

export const getEmailBodyHeadingStyles = (theme: Theme): SerializedStyles =>
    css({
        textAlign: 'center',
        backgroundColor: theme.palette.info.light,
        opacity: 0.5,
    });

export const getEmailFormSubmitBtnStyles = (theme: Theme): SerializedStyles =>
    css({
        alignSelf: 'flex-end',
        marginTop: theme.spacing(2),
        marginRight: theme.spacing(4),
    });

export const getMainStyles = (theme: Theme): SerializedStyles =>
    css({
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.gray[100],
    });
